import { LogoIcon } from "@/components/icons/logo-icon";
import { IonHeader } from "@ionic/react";

import { HeaderSubtitle } from "@/components/header/subtitle";
import { HeaderTitle } from "@/components/header/title";
import { useSafeAreaStyles } from "@/hooks/utils/use-safe-area-styles";
import { textVariants } from "@/utils/text-variants";
import {} from "@capacitor/app";
import { IonToolbar } from "@ionic/react";
import { memo } from "react";
import { BackButton } from "../back-button";

interface BackToolbarComponentProps {
  showLogo?: boolean;
  title?: string;
  titleFontSize?: keyof typeof textVariants;
  subtitle?: string;
  actionButton?: React.ReactNode;
  isStepRoute?: boolean;
  bgColor?: string;
  onBack?: () => void;
}

export const BackToolbarComponent = memo(function BackToolbarComponent({
  showLogo = false,
  title,
  titleFontSize = "title1",
  subtitle,
  actionButton,
  isStepRoute = false,
  bgColor,
  onBack,
}: BackToolbarComponentProps) {
  const safeAreaStyles = useSafeAreaStyles();
  return (
    <IonHeader color={bgColor}>
      <IonToolbar className="safe-area-top mx-auto max-w-[450px]" style={{ ...safeAreaStyles }}>
        <div className="flex w-full items-center bg-white px-6 pt-2">
          <BackButton isStepRoute={isStepRoute} onBack={onBack} />

          {showLogo && (
            <LogoIcon className="fixed top-1/2 left-1/2 max-w-[120px] -translate-x-1/2 -translate-y-1/2" />
          )}

          <div className="flex flex-1 flex-col items-center justify-center gap-2">
            {title && <HeaderTitle title={title} titleFontSize={titleFontSize} />}
            {subtitle && <HeaderSubtitle subtitle={subtitle} subtitleFontSize="bodySmall" />}
          </div>

          {actionButton ? actionButton : <div slot="end" className="h-11 w-11" />}
        </div>
      </IonToolbar>
    </IonHeader>
  );
});
